/**
 * ViewBlock.
 * @module components/manage/Blocks/Text/View
 */

import React from 'react';
import PropTypes from 'prop-types';
import redraft from 'redraft';
import { UniversalLink } from '@plone/volto/components';
import config from '@plone/volto/registry';

/**
 * ViewBlock class.
 * @class ViewBlock
 * @extends Component
 */
const ViewBlock = ({ data }) => {
  let content = (
    <>
      {data.title && (
        <div className="title">
          {redraft(
            data.title,
            config.settings.richtextViewSettings.ToHTMLRenderers,
            config.settings.richtextViewSettings.ToHTMLOptions,
          )}
        </div>
      )}
      {data.description && (
        <div className="description">
          {redraft(
            data.description,
            config.settings.richtextViewSettings.ToHTMLRenderers,
            config.settings.richtextViewSettings.ToHTMLOptions,
          )}
        </div>
      )}
    </>
  );

  if (data.href) {
    content = (
      <UniversalLink href={data.href} openLinkInNewTab={data.openLinkInNewTab}>
        {content}
      </UniversalLink>
    );
  }

  return <div className="single-block">{content}</div>;
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ViewBlock.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default ViewBlock;
